import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'netikash-theme';

const ThemeContext = createContext({
  theme: 'light',
  setTheme: () => {},
  toggleTheme: () => {},
});

/**
 * Thème global : 'light' | 'dark'
 * Applique la classe `dark` sur <html> pour Tailwind (darkMode: 'class').
 */
export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    if (typeof window === 'undefined') return 'light';
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'dark' || stored === 'light') return stored;
    } catch (e) {
      /* ignore */
    }
    return 'light';
  });

  useEffect(() => {
    var root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
      /* ignore */
    }
  }, [theme]);

  var setTheme = function (t) {
    if (t === 'dark' || t === 'light') setThemeState(t);
  };

  var toggleTheme = function () {
    setThemeState(function (prev) {
      return prev === 'dark' ? 'light' : 'dark';
    });
  };

  var value = useMemo(
    function () {
      return { theme: theme, setTheme: setTheme, toggleTheme: toggleTheme };
    },
    [theme]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}
